import React from 'react';
import './About.css'; // Assuming you'll have some CSS for styling this page
import Navbar from '../../components/navigationbar/Navbar';
import Footer from '../../components/Footer/Footer';
import logo from '../../assets/gpa-logo.jpg'
const About = () => {

  return (
    <>
    <Navbar/>
    {/* <div className="carousel">
        <div className="carousel-slider">
          <img
            width={"100%"}
            height={"300px"}
            src={"https://media.istockphoto.com/id/1403180911/photo/wooden-block-with-medical-icons.jpg?s=612x612&w=0&k=20&c=9K9WRyXGyCoMBGSEIWrnm7B2OnaiZ2ULJ6fk3NdWRYw="} />
          <br />
        </div>
        <div className="carousel-caption">
          <h1>ABOUT US</h1>
        </div>
      </div> */}

    <div className="about">
        
      <div className="about-us-header">
       
      <center> <img
       src={logo}
       width={"200px"}
       draggable="false" oncontextmenu="return false "
       /></center>
        <p>
          Welcome to the General Practitioner's Association of Ichalkaranji, a leading professional organization committed to fostering excellence in healthcare through education, collaboration, and community. Our members include doctors from diverse fields such as Allopathy, Homeopathy, and Ayurveda, united by a shared dedication to advancing medical science and improving patient care.
        </p>
      </div>
      
      <div className="about-us-content">
        <h2>Our History</h2>
        <p>
        Established in 2018, the GPA was founded by a group of forward-thinking physicians who recognized the need for a multidisciplinary platform where medical professionals could come together to share knowledge, skills, and experiences. Over the past 6 years, GPA has grown into a vibrant and dynamic community of practitioners, providing a valuable network for learning, growth, and professional development. 
        </p>

        <h2>Our Mission</h2>
        <p>
          Our mission is to support the continuous professional development of our members by providing access to cutting-edge medical knowledge, innovative treatment strategies, and practical skills training. We are dedicated to fostering a spirit of lifelong learning among healthcare providers, ensuring that they remain at the forefront of medical advancements and provide the highest standard of care to their patients.
        </p>

        <h2>What We Do</h2>
        <p>
          GPA organizes a variety of educational activities and events designed to enhance the knowledge and skills of our members:
        </p>
        <ul>
          <li>
            <strong>Case-Based Discussions:</strong> Regular sessions where members can present and discuss challenging clinical cases, promoting peer learning and critical thinking.
          </li>
          <li>
            <strong>Continuing Medical Education (CME) Programs:</strong> Accredited programs offering the latest updates in medical science, research, and practice, delivered by experts from various specialties.
          </li>
          <li>
            <strong>Workshops and Hands-On Training:</strong> Practical sessions focusing on specific skills, techniques, and procedures, enabling doctors to gain hands-on experience under the guidance of experienced professionals.
          </li>
          <li>
            <strong>Conferences and Seminars:</strong> Annual events bringing together leading experts and practitioners to share knowledge, discuss trends, and network with peers.
          </li>
          <li>
            <strong>Online Learning Resources:</strong> Access to a comprehensive library of medical literature, webinars, and e-learning modules tailored to the needs of our members.
          </li>
        </ul>

        <h2>Our Values</h2>
        <p>
          At the heart of GPA are our core values:
        </p>
        <ul>
          <li>
            <strong>Excellence:</strong> Striving for the highest standards in education, practice, and patient care.
          </li>
          <li>
            <strong>Integrity:</strong> Upholding ethical principles and transparency in all our activities.
          </li>
          <li>
            <strong>Collaboration:</strong> Encouraging teamwork, sharing of knowledge, and partnerships across disciplines.
          </li>
          <li>
            <strong>Innovation:</strong> Embracing new ideas, technologies, and approaches to improve healthcare delivery.
          </li>
          <li>
            <strong>Community:</strong> Building a supportive network where all members feel valued, respected, and inspired.
          </li>
        </ul>

        <h2>Our Impact</h2>
        <p>
          GPA's impact extends beyond the individual members to the communities they serve. By fostering a culture of continuous learning and improvement, our association contributes to higher standards of patient care, better health outcomes, and a more informed and engaged medical community. We take pride in being a trusted resource and advocate for our members, ensuring they have the tools and knowledge needed to excel in their practice.
        </p>

        <h2>Why Join Us?</h2>
        <p>
          Joining the GPA offers numerous benefits, including access to exclusive educational content, networking opportunities, mentorship programs, and professional recognition. Whether you are an experienced practitioner or new to the field, GPA provides a supportive environment to advance your career, expand your knowledge, and contribute to the future of medicine.
        </p>

        <h2>Contact Us</h2>
        <p>
          For more information about GPA, membership inquiries, or upcoming events, please feel free to contact us at <a href="mailto:gpaichalkaranji@gmail.com">gpaichalkaranji@gmail.com</a>. We look forward to welcoming you to our community!
        </p>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default About;
